import script from "./SessionSectionV2.vue?vue&type=script&lang=js"
export * from "./SessionSectionV2.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__